import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CommonBroadcastService {
    public static $name = 'commonBroadcastService';

    private eventBus: Subject<any>;

    constructor() {
        this.eventBus = new Subject<any>();
    }

    public broadcast(key: any, data?: any) {
        this.eventBus.next({key, data});
    }

    /**
     * Observable for events defined by identification key
     * @param key event identification
     */
    public on<T>(key: any): Observable<T> {
        return this.eventBus.asObservable()
            .pipe(filter(event => event.key === key))
            .pipe(map(event => event.data as T));
    }
}
